import { useEffect, useState } from "react";
import { ethers } from "ethers";
import ERC20ABI from "../abi/ERC20ABI.json";
import { useAtom } from "jotai";
import { tokenContractAddress } from "../stateManagement/tokenAddressAtom";

export const useAssetUpdaterList = (provider: ethers.ContractRunner | null | undefined) => {
  const [data, setData] = useState([]);
  const tokenAddress = localStorage.getItem("tokenContractAddress");

  const getAssetUpdatersList = async (offset: any, limit: any) => {
    // const tokenContract = new ethers.Contract(
    //   process.env.REACT_APP_CONTRACT_ADDRESS || "",
    //   ERC20ABI.abi,
    //   provider
    // );

    const tokenContract = new ethers.Contract(
      tokenAddress || "",
      ERC20ABI.abi,
      provider
    );

    const res = await tokenContract.getAssetUpdatersListPagination(offset, limit);
    setData(res);
  };

  useEffect(() => {
    getAssetUpdatersList(0, 1000).catch(console.error)

    const refreshInterval = setInterval(() => getAssetUpdatersList(0, 1000).catch(console.error), 5000)
    return () => clearInterval(refreshInterval)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    assetUpdaterList: data,
    getAssetUpdatersList: getAssetUpdatersList
  };
};
